module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Db-Ge-Ha-Ia.5bd7967b.png";